import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type {
  ActualizeazaTargetareTintaRequest,
  ActualizeazaTargetareTintaResponse,
  AdaugaTargetareTinteRequest,
  AdaugaTargetareTinteResponse,
  GetTargetareActivitateResponse,
  GetTargetareTinteResponse,
  SalveazaTargetareCampanieRequest,
  SalveazaTargetareCampanieResponse,
  SincronizeazaTargetareActivitateResponse,
  StergeTargetareCampanieRequest,
  StergeTargetareTintaRequest,
} from "@/api/types/targetareTinte";

function assertSuccess(data: unknown, endpoint: string): void {
  if (
    !data ||
    typeof data !== "object" ||
    (data as { success?: unknown }).success !== true
  ) {
    throw new Error(`Răspuns invalid de la ${endpoint}`);
  }
}

export async function getTargetareTinte(): Promise<GetTargetareTinteResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/tinte",
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/tinte");
  return data;
}

export async function adaugaTargetareTinte(
  request: AdaugaTargetareTinteRequest
): Promise<AdaugaTargetareTinteResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/tinte",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/tinte");
  return data;
}

export async function actualizeazaTargetareTinta(
  request: ActualizeazaTargetareTintaRequest
): Promise<ActualizeazaTargetareTintaResponse> {
  const { id, ...body } = request;
  const { data, error } = await supabase.functions.invoke(
    `api/targetare/tinte/${id}`,
    { method: "PATCH", body }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/tinte/:id");
  return data;
}

export async function stergeTargetareTinta(
  request: StergeTargetareTintaRequest
): Promise<void> {
  const { error } = await supabase.functions.invoke(
    `api/targetare/tinte/${request.id}`,
    { method: "DELETE" }
  );
  await handleSupabaseFunctionError(error);
}

export async function salveazaTargetareCampanie(
  request: SalveazaTargetareCampanieRequest
): Promise<SalveazaTargetareCampanieResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/campanii",
    { method: "POST", body: request }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/campanii");
  return data;
}

export async function stergeTargetareCampanie(
  request: StergeTargetareCampanieRequest
): Promise<void> {
  const { error } = await supabase.functions.invoke(
    `api/targetare/campanii/${request.id}`,
    { method: "DELETE" }
  );
  await handleSupabaseFunctionError(error);
}

export async function getTargetareActivitate(): Promise<GetTargetareActivitateResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/activitate",
    { method: "GET" }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/activitate");
  return data;
}

export async function sincronizeazaTargetareActivitate(): Promise<SincronizeazaTargetareActivitateResponse> {
  const { data, error } = await supabase.functions.invoke(
    "api/targetare/activitate/sincronizeaza",
    { method: "POST", body: {} }
  );
  await handleSupabaseFunctionError(error);
  assertSuccess(data, "targetare/activitate/sincronizeaza");
  return data;
}
